// extracted by mini-css-extract-plugin
module.exports = {"applicantIcon":"styles_applicantIcon__3JXiT"};